export const REPORT_IDS = {
  SOP_DETAILS: 48,
  CUSTODY_LIST: 310, // RMSCustodyListReport
  ITEM_RECORD: 270, // RMSEvidenceItemRecord
  CUSTODY_RECEIPT: 271, // RMSCustodyReceiptReport
  CUSTODY_RECEIPT_ALL_IN_ONE: 272, // RMSCustodyReceiptAllInOneReport
  PROPERTY_RETURN_RECEIPT: 273, // RMSPropertyReturnReceiptReport
  LABEL_4_X_6: 289, // RMSEvidenceLabel46
  LABEL_2_X_4: 266, // RMSEvidenceLabel
};
